import axios from 'axios';
import endpoint from '@app/endpoint';

export const resetPassword = (formData, flowConfig) => {
  const url = flowConfig.getResourceURL('dpo8-sso-reset-password');
  const clientId = flowConfig.authentication.getParamValue('sso-client-id');
  const { method = 'POST' } = flowConfig.authentication.findRequest('dpo8-reset-password');
  const payload = {
    email: formData.email,
    clientId,
    target: endpoint.target,
    type: 'password',
    template: 'email_reset',
  };

  const headers = {
    'Content-Type': 'application/json',
  };
  if (method === 'PUT') {
    return axios.put(url, payload, { headers });
  }
  return axios.post(url, payload, { headers });
};

export const createAccount = (flowConfig, data, onSuccess, onFail) => () => {
  const url = flowConfig.getResourceURL('dpo8-sso-sign-up');
  endpoint.createAccount(url, data, onSuccess, onFail);
};
